import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType, CommonRoutes,
} from 'app/enums/common.enums'
import {
    LeaseType,
} from 'app/enums/label.enums'
import {
    kamCompleted,
} from '../KamDashboard.types'

const kamDashboardConfig: SkyNetTableConfig<keyof kamCompleted> = {
    name: 'kamCompleted',
    tabs: [{
        name: 'Completed',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'quoteNumber',
                labelKey: 'AccountQuotes.quoteNumber',
            },
            {
                name: 'customerQuotationLocationName',
                labelKey: 'AccountQuotes.customerQuotation',
            },
            {
                name: 'accountName',
                labelKey: 'AccountLane.accountCompanyName',
                filterField: 'accountName',
                filterType: FilterType.Array,
            },
            {
                name: 'leaseType',
                labelKey: 'AccountLane.leaseType',
                filterField: 'leaseType',
                componentName: 'EnumValue',
                filterType: FilterType.Array,
                allowedValuesEnum: LeaseType,
            },
            {
                name: 'pricingResponsible',
                labelKey: 'AccountQuotes.pricingResponsible',
                componentName: 'List',
            },
            {
                name: 'createdBy',
                labelKey: 'KamDashboard.requestor',
                sorting: false,
            },
            {
                name: 'totalLanes',
                labelKey: 'KamDashboard.totalLanes',
                sorting: false,
            },
            {
                name: 'lastUpdated',
                labelKey: 'KamDashboard.lastUpdated',
                sorting: false,
                componentName: 'DateTimeCell',
            },
        ],
    }],
}

export default kamDashboardConfig
